<template>
<header id="headerWrap">
  <div id="header">
    <div id="logoWrap">
      <a href="javascript: void(0)" @click="refresh()"><img src="../../../assets/images/saipa_logo_fa.png" width="58" height="74" alt="" /></a>
    </div>

    <div id="loginNav">
      <img src="../../../assets/images/nav_global.png" width="18" height="18" alt="" />
      <div id="language">
        <select v-model="selected" @change="selectLanguage()">
          <option value="EN" >English</option>
          <option value="FAR">فارسي</option>          
          <option value="AR">العربية</option>
        </select>
        <!-- <a href="javascript: void(0)" title="EN" @click="changeLanguage()">English</a> -->
      </div>
      <label id="userName">{{ userName }}</label>
    </div>
  </div>
</header>
</template>
<script>
import router from '../../../router.js';
export default {
  props: {
    userName: String,
  },
  data: function() {
    return {
      selected: 'FAR'
    }
  },
  methods: {
    changeLanguage: function() {
      var strPath = 'http://saipa.polstargps.com/maptool/mapupdater3/saipa/#';
      location.replace(strPath + this.$route.path);
    },
    refresh() {
      if (this.$route.path === '/') router.replace('/');
      else if (this.$route.path !== '/Main/Index') router.replace('/Main/Index');
    },
    selectLanguage: function() {
      var language = this.selected;
      var strPath = 'http://saipa.polstargps.com/maptool/mapupdater3/saipa/#';
      switch (language) {
        case 'FAR':
          strPath = 'http://saipa.polstargps.com/maptool/mapupdater3/saipa/FAR/#';
          location.replace(strPath + this.$route.path);
          break;
        case 'AR':
          strPath = 'http://saipa.polstargps.com/maptool/mapupdater3/saipa/AR/#';
          location.replace(strPath + this.$route.path);
          break;
        default:
          location.replace(strPath + this.$route.path);
          break;
      }
    },
  },
  mounted() {
    if (this.$route.path.substr(0, 5) === '/Main' && !sessionStorage.getItem('email')) {
      // auto logout
      router.replace('/');
    }
  },
  watch: {
    $route() {
      var subPath = this.$route.path.substr(0, 5);
      if (subPath === '/Main' && !sessionStorage.getItem('email')) {
        // auto logout
        router.replace('/');
      }
    }
  }
};
</script>
<style scoped>
label {
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// Header.vue?03b091bc